<template>
  <div class="main_right">
    <breadcrumb :breadcrumb="config.breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备名称：</span>
        </div>
        <el-input v-model="deviceName" size="small" style="width: 280px" />
        <span v-html="deviceNameVer"></span>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备编号：</span>
        </div>
        <el-input v-model="deviceCode" size="small" style="width: 280px" />
        <span v-html="deviceCodeVer"></span>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备类型：</span>
        </div>
        <el-select v-model="deviceType" size="small" style="width: 280px">
          <el-option v-for="item in deviceTypeList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备厂家：</span>
        </div>
        <el-select v-model="deviceManufacturer" size="small" style="width: 280px">
          <el-option v-for="item in deviceManufacturerList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备型号：</span>
        </div>
        <el-select v-model="deviceModelName" size="small" style="width: 280px">
          <el-option v-for="item in deviceModelNameList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">接入协议:</span>
        </div>
        <el-select v-model="protocolType" size="small" style="width: 280px">
          <el-option
            v-for="item in protocolTypeList"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          >
          </el-option>
        </el-select>
      </div>

      <div class="form-line" v-if="deviceManufacturer === '100061' && deviceType !== '5' ">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备账号：</span>
        </div>
        <el-input v-model="userName" size="small" style="width: 280px" />
      </div>

      <div class="form-line" v-if="deviceManufacturer === '100061' && deviceType !== '5' ">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备密码：</span>
        </div>
        <el-input v-model="password" type="password" size="small" style="width: 280px" />
      </div>

      <div class="form-line" v-if="hasParent">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">所属网关：</span>
        </div>
        <el-select v-model="parentCode"
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="remoteParentMethod"
                   placeholder="请输入关键词查询">
          <el-option v-for="item in parentList" :key="item._value"
                     :label="item._label" :value="item._value">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">开门计划：</span>
        </div>
        <el-select v-model="openPlanId" size="small" style="width: 280px">
          <el-option v-for="item in openPlanIdList" :key="item.code"
                     :label="item.planName" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">应用场景：</span>
        </div>
        <el-select v-model="scence" size="small" style="width: 280px">
          <el-option v-for="item in scenceList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line" v-if="scence === '2'">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备所在房间：</span>
        </div>
        <input-tree :fetch="fetchDetail" :showCheckBox="false" @chooseLine="getRoomList" :theValue="roomCode" :theName="roomNumber" style="width: 280px" />
      </div>

      <div class="form-line" v-if="scence === '2'">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备所属住户：</span>
        </div>
        <el-select v-model="enterpriseCode" size="small" style="width: 280px">
          <el-option v-for="item in enterpriseList" :key="item.code"
                     :label="item.enterpriseName" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">进出类型：</span>
        </div>
        <el-select v-model="passType" size="small" style="width: 280px">
          <el-option v-for="item in passTypeList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备用途：</span>
        </div>
        <el-select v-model="devicePurpose" size="small" style="width: 280px">
          <el-option v-for="item in devicePurposeList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">设备位置：</span>
        </div>
        <el-input v-model="location" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <!--<b class="red">*</b>-->
          <span class="line-text">责任人：</span>
        </div>
        <el-select v-model="responsiblePerson"
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="remoteMethod"
                   placeholder="请输入关键词查询">
          <el-option v-for="item in responsiblePersonList" :key="item._value"
                     :label="item._label" :value="item._value">
          </el-option>
        </el-select>
        <span v-html="responsiblePersonVer"></span>
      </div>


      <!--<div class="flex-align-center margin-top-12" style="margin-left: 22px;">-->
        <!--<span style="color: red;">*</span>-->
        <!--<span class="margin-right-16">设备组织：</span>-->
        <!--<input-tree class="input-tree"-->
                    <!--:fetch="config.tree.fetch"-->
                    <!--:default-value="1"-->
                    <!--@input="handleEntitySelected"-->
        <!--/>-->
      <!--</div>-->

      <div class="form-btn-box">
        <button-confirm @confirm="add" />
        <button-confirm-next @confirm="addNext" value="添加下一项" />
        <button-cancel @cancel="strategyCenter" />
      </div>

    </form>
  </div>
</template>

<script>
import BreadCrumb from '../../../components/common/di-ding/common/bread-crumb'
import {commonConfig} from '../common'
import {errorHandler} from '../../../utils/errorHandler'
import InputTree from '../../../components/common/inputs/input-tree'
import {pattern} from '../../../utils/regular'
import {api} from '../../api/access-ctrl'
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import TextTitle from '../../../components/Text/TextTitle'
import ButtonCancel from '../../../components/Button/ButtonCancel'
import ButtonConfirm from '../../../components/Button/ButtonConfirm'
import {nError, nSuccess} from '../../../utils/notice'
import ButtonConfirmNext from '../../../components/Button/ButtonConfirmNext'
import {treeApi} from '../../api/TreeApi'
import {bus} from '../../../utils/bus'
// let a = document.getElementsByClassName()

export default {
  components: {
    ButtonConfirmNext,
    ButtonConfirm,
    ButtonCancel,
    TextTitle,
    Breadcrumb,
    InputTree,
    BreadCrumb
  },
  name: 'add-device',
  data () {
    return {
      config: {
        breadcrumb: [{
          value: '智慧门禁',
          name: 'accessCtrlDeviceManagementCenter'
        }, {
          value: '设备管理',
        }],
        // tree: {
        //   fetch: () => api.getBusinessTreeList().then(list => {
        //     list.forEach(tree => {
        //       tree._value = tree.id
        //       tree._label = tree.label = tree.businessEntityName
        //     })
        //     return list
        //   })
        // }
      },
      mainTitle: '添加门禁设备',
      subheading: '门禁设备以主动注册方式连接平台',
      deviceName: '',
      deviceNameVer: '<span>不超过32个字</span>',
      deviceCode: '',
      deviceCodeVer: '<span>填写门禁设备序列号，与设备保持一致且唯一</span>',
      deviceType: '1',
      deviceTypeList: [
        {code: '1', name: '二维码云门禁一体机'},
        // {code: '2', name: '二维码签到终端'},
        {code: '3', name: '人脸识别终端'},
        // {code: '4', name: '人脸签到终端'},
        // {code: '5', name: '二维码云门禁控制器'},
        // {code: '6', name: '二维码核身终端'},
        // {code: '7', name: '人脸闸机网关'}
        {code: '14', name: '门禁一体机'}
      ],
      deviceManufacturer: '',
      deviceManufacturerList: [],
      deviceModelName: '',
      deviceModelNameList: [],
      protocolType: '主动注册',
      protocolTypeList: [
        {code: '主动注册', name: '主动注册'},
        {code: '大华云睿', name: '大华云睿'},
      ],
      openPlanId: '',
      openPlanIdList: [],
      enterpriseCode: '',
      enterpriseName: '',
      enterpriseList: [],
      scence: '1',
      scenceList: [
        {code: '1', name: '公共场景'},
        {code: '2', name: '住户场景'},
        {code: '4', name: '预约场景'},
        {code: '3', name: '其他场景'},
        {code: '5', name: '看房场景'}
      ],
      passType: '3',
      passTypeList: [
        {code: '1', name: '进'},
        {code: '2', name: '出'},
        {code: '3', name: '进/出'},
      ],
      devicePurpose: '1',
      devicePurposeList: [
        {code: '1', name: '仅门禁'},
        {code: '2', name: '仅考勤'},
        {code: '3', name: '门禁和考勤'},
      ],
      responsiblePerson: '',
      responsiblePersonList: [],
      responsiblePersonVer: '<span>门禁设备责任人</span>',
      hasParent: false,
      parentCode: '',
      parentName: '',
      parentList: [],
      hasResponsiblePerson: true,
      roomCode: '',
      roomNumber: '',
      deviceNameHttp: false,
      deviceCodeHttp: false,
      fetchDetail: null,
      organizationCode: '',
      organizationName: '',
      userName: '',
      password: '',
      location: ''
    }
  },
  created () {
    this.organizationCode = window.sessionStorage.getItem('organizationCode')
    this.organizationName = window.sessionStorage.getItem('organizationName')
    this.getAllDeviceManufacture()
    this.getOpenPlanList()
    this.remoteMethod()
    this.getGatewayDeviceList()
    this.fetchDetail = () => {
      let treeList = []
      let yqCode = ''
      return treeApi.getYqInfo()
        .then(yqData => {
          let yqObj = {}
          yqCode = yqData.yqCode
          yqObj._value = yqData.yqCode
          yqObj._label = yqData.yqName
          yqObj.parentCode = '0'
          yqObj.level = 1
          yqObj.code = yqData.yqCode
          treeList.push(yqObj)

          treeApi.getVacancyRoomInfo(this.currentCode)
            .then(roomList => {
              roomList.map(room => {
                let roomObj = {}
                roomObj.buildingName = room.buildingName
                roomObj._value = room.code
                roomObj._label = room.roomNumber
                roomObj.parentCode = room.floorCode
                roomObj.level = 4
                roomObj.code = room.code
                roomObj.roomArea = room.roomArea
                roomObj.roomRent = room.roomRent
                roomObj.roomType = room.roomType
                treeList.push(roomObj)
              })
            })

          treeApi.getBuildingList()
            .then(buildingList => {
              buildingList.map(v => {
                let obj = {}
                obj._value = v.code
                obj._label = v.name
                obj.parentCode = yqCode
                obj.level = 2
                obj.code = v.code
                treeList.push(obj)
                if (v.floors.length > 0) {
                  v.floors.map(floor => {
                    let floorObj = {}
                    floorObj._value = floor.code
                    floorObj._label = floor.name
                    floorObj.parentCode = floor.buildingCode
                    floorObj.level = 3
                    floorObj.code = floor.code
                    treeList.push(floorObj)
                  })
                }
              })

            })
          return treeList
        })
    }
  },
  methods: {
    remoteParentMethod (query) {
      this.getGatewayDeviceList(query)
    },
    // 获取网关列表
    getGatewayDeviceList (query) {
      api.getGatewayDeviceList({
        searchKey: query || ''
      })
        .then(data => {
          data.forEach(it => {
            it._value = it.deviceCode
            it._label = it.deviceName
          })
          this.parentList = data
        })
        .catch(errorHandler('获取网关列表失败'))
    },
    // 获取房间下的住户
    getEnterpriseListByRoom () {
      api.getEnterpriseListByRoom({
        roomInfoCode: this.roomCode
      })
        .then(data => {
          this.enterpriseList = data
        })
        .catch(errorHandler('获取住户失败'))
    },
    getEnterpriseByCode () {
      api.getEnterpriseByCode(this.enterpriseCode)
        .then(data => {
          let enterpriseHasRoomCode = []
          let enterpriseHasRoomNumber = []
          if (data.roomCode.indexOf(',') === -1) {
            enterpriseHasRoomCode = [data.roomCode]
          } else {
            enterpriseHasRoomCode = data.roomCode.split(',')
          }
          if (data.roomNumber.indexOf(',') === -1) {
            enterpriseHasRoomNumber = [data.roomNumber]
          } else {
            enterpriseHasRoomNumber = data.roomNumber.split(',')
          }
          for (let i = 0; i < enterpriseHasRoomCode.length; i++) {
            let obj = {}
            obj.code = enterpriseHasRoomCode[i]
            obj.name = enterpriseHasRoomNumber[i]
            this.enterpriseHasRoomList.push(obj)
          }
        })
        .catch(errorHandler('获取责任人列表失败'))
    },
    getEnterpriseInfoList () {
      api.getEnterpriseInfoList()
        .then(data => {
          this.enterpriseList = data
          this.enterpriseList.map(v => {
            if (v.code === this.enterpriseCode) {
              this.enterpriseName = v.enterpriseName
            }
          })
        })
        .catch(errorHandler('获取住户信息失败'))
    },
    getAllDeviceManufacture () {
      api.getAllDeviceManufacture({
        moduleCode: '1',
        deviceType: this.deviceType
      })
        .then(data => {
          this.deviceManufacturerList = data
          if (this.deviceManufacturerList.length > 0) {
            this.deviceManufacturer = data[0].code
            this.getAllDeviceType()
          }
        })
        .catch(errorHandler('获取设备厂家失败'))
    },
    getAllDeviceType () {
      api.getAllDeviceType({
        moduleCode: '1',
        deviceType: this.deviceType,
        deviceManufactureCode: this.deviceManufacturer
      })
        .then(data => {
          this.deviceModelNameList = data
          if (this.deviceModelNameList.length > 0) {
            this.deviceModelName = data[0].code
          }
        })
        .catch(errorHandler('获取设备型号失败'))
    },
    getOpenPlanList () {
      api.getOpenPlanList()
        .then(data => {
          this.openPlanIdList = data
          if (this.openPlanIdList.length > 0) {
            this.openPlanId = this.openPlanIdList[0].code
          }
        })
        .catch(errorHandler('获取开门计划失败'))
    },
    // 查询园区管理员
    getResponsiblePersonList (searchKey) {
      api.getResponsiblePerson(searchKey || '')
        .then(list => {
          list.forEach(it => {
            it._value = it.code
            it._label = `${it.name} / ${it.phone} / ${it.enterpriseName}`
          })
          this.responsiblePersonList = list
        })
    },
    // 查询企业管理员
    getEnterprisePerson (searchKey) {
      api.getEnterprisePerson({
        searchKey: searchKey || '',
        enterpriseCode: this.enterpriseCode,
        cardTypeCode: `${bus.global.yqCode}A00000003`,
      })
        .then(list => {
          list.forEach(it => {
            it._value = it.code
            it._label = `${it.name} / ${it.phone} / ${it.enterpriseName}`
          })
          this.responsiblePersonList = list
        })
    },
    remoteMethod (query) {
      if (this.scene === '2') {
        this.getEnterprisePerson(query)
      } else {
        this.getResponsiblePersonList(query)
      }
    },
    getRoomList (v) {
      this.roomCode = v.code
      this.roomNumber = v.buildingName + v._label
    },
    addNext () {
      if (!this.deviceName) {
        this.deviceNameVer = '<span style="color: red;">请输入设备名称</span>'
        return false
      }
      if (!this.deviceCode) {
        this.deviceCodeVer = '<span style="color: red;">请输入设备编号</span>'
        return false
      }
      // if (!this.responsiblePerson) {
      //   this.responsiblePersonVer = '<span style="color: red;">请选择设备责任人</span>'
      //   return false
      // }
      if (this.scence === '2' && !this.roomCode && !this.enterpriseCode ) {
        this.responsiblePersonVer = '<span style="color: red;">请选择设备所在房间及住户</span>'
        return false
      }
      if (!this.deviceCodeHttp || !this.deviceNameHttp) {
        return false
      } else {
        this.deviceNameVer = '<span>不超过32个字</span>'
        this.deviceCodeVer = '<span>填写门禁设备序列号，与设备保持一致且唯一</span>'
        this.responsiblePersonVer = '<span>门禁设备责任人</span>'
      }
      if (this.deviceManufacturer === '100061' && this.deviceType !== '5' && (!this.userName || !this.password)) {
        nError('请输入设备账户和密码')
        return false
      }
      let obj = {
        deviceName: this.deviceName,
        deviceCode: this.deviceCode,
        deviceManufacturerCode: this.deviceManufacturer,
        deviceManufacturerName: '',
        deviceModelCode: this.deviceModelName,
        deviceModelName: '',
        protocolType: this.protocolType,
        openPlanCode: this.openPlanId,
        enterpriseCode: this.enterpriseCode,
        enterpriseName: '',
        organizationCode: this.organizationCode,
        organizationName: this.organizationName,
        planName: '',
        responsiblePersonCode: this.responsiblePerson,
        responsiblePersonName: '',
        deviceManufacturer: this.deviceManufacturer,
        scence: this.scence,
        passType: this.passType,
        devicePurpose: this.devicePurpose,
        scenceName: '',
        roomCode: this.roomCode,
        roomNumber: this.roomNumber,
        deviceType: this.deviceType,
        parentCode: this.parentCode,
        parentName: this.parentName,
        userName: this.userName,
        password: this.password,
        location: this.location
      }
      this.openPlanIdList.map(v => {
        if (v.code === this.openPlanId) {
          obj.planName = v.planName
        }
      })
      this.deviceManufacturerList.map(v => {
        if (v.code === this.deviceManufacturer) {
          obj.deviceManufacturerName = v.name
        }
      })
      this.deviceModelNameList.map(v => {
        if (v.code === this.deviceModelName) {
          obj.deviceModelName = v.name
        }
      })
      this.scenceList.map(v => {
        if (v.code === this.scence) {
          obj.scenceName = v.name
        }
      })
      this.responsiblePersonList.map(v => {
        if (v.code === this.responsiblePerson) {
          obj.responsiblePersonName = v._label
          obj.responsiblePersonCode = v.code
        }
      })
      this.enterpriseList.map(v => {
        if (v.code === this.enterpriseCode) {
          obj.enterpriseName = v.enterpriseName
        }
      })
      api.addAccessDevice(obj)
        .then(() => {
          nSuccess('添加成功')
          this.deviceName = ''
          this.deviceCode = ''
          this.responsiblePerson = ''
        })
        .catch(errorHandler('添加门禁设备失败'))
    },
    add () {
      if (!this.deviceName) {
        this.deviceNameVer = '<span style="color: red;">请输入设备名称</span>'
        return false
      }
      if (!this.deviceCode) {
        this.deviceCodeVer = '<span style="color: red;">请输入设备编号</span>'
        return false
      }
      // if (!this.responsiblePerson) {
      //   this.responsiblePersonVer = '<span style="color: red;">请选择设备责任人</span>'
      //   return false
      // }
      if (this.scence === '2' && !this.roomCode && !this.enterpriseCode ) {
        this.responsiblePersonVer = '<span style="color: red;">请选择设备所在房间及住户</span>'
        return false
      }
      if (!this.deviceCodeHttp || !this.deviceNameHttp) {
        return false
      } else {
        this.deviceNameVer = '<span>不超过32个字</span>'
        this.deviceCodeVer = '<span>填写门禁设备序列号，与设备保持一致且唯一</span>'
        this.responsiblePersonVer = '<span>门禁设备责任人</span>'
      }
      if (this.deviceManufacturer === '100061' && this.deviceType !== '5' && (!this.userName || !this.password)) {
        nError('请输入设备账户和密码')
        return false
      }
      let obj = {
        deviceName: this.deviceName,
        deviceCode: this.deviceCode,
        deviceManufacturerCode: this.deviceManufacturer,
        deviceManufacturerName: '',
        deviceModelCode: this.deviceModelName,
        deviceModelName: '',
        protocolType: this.protocolType,
        openPlanCode: this.openPlanId,
        enterpriseCode: this.enterpriseCode,
        enterpriseName: '',
        organizationCode: this.organizationCode,
        organizationName: this.organizationName,
        planName: '',
        responsiblePersonCode: this.responsiblePerson,
        responsiblePersonName: '',
        deviceManufacturer: this.deviceManufacturer,
        scence: this.scence,
        passType: this.passType,
        devicePurpose: this.devicePurpose,
        scenceName: '',
        roomCode: this.roomCode,
        roomNumber: this.roomNumber,
        deviceType: this.deviceType,
        parentCode: this.parentCode,
        parentName: this.parentName,
        userName: this.userName,
        password: this.password,
        location: this.location
      }
      this.openPlanIdList.map(v => {
        if (v.code === this.openPlanId) {
          obj.planName = v.planName
        }
      })
      this.deviceManufacturerList.map(v => {
        if (v.code === this.deviceManufacturer) {
          obj.deviceManufacturerName = v.name
        }
      })
      this.deviceModelNameList.map(v => {
        if (v.code === this.deviceModelName) {
          obj.deviceModelName = v.name
        }
      })
      this.scenceList.map(v => {
        if (v.code === this.scence) {
          obj.scenceName = v.name
        }
      })
      this.responsiblePersonList.map(v => {
        if (v.code === this.responsiblePerson) {
          obj.responsiblePersonName = v._label
          obj.responsiblePersonCode = v.code
        }
      })
      this.enterpriseList.map(v => {
        if (v.code === this.enterpriseCode) {
          obj.enterpriseName = v.enterpriseName
        }
      })
      api.addAccessDevice(obj)
        .then(() => {
          nSuccess('添加成功')
          this.$router.push({
            path: '/access-control/device/center'
          })
        })
        .catch(errorHandler('添加门禁设备失败'))
    },
    strategyCenter () {
      this.$router.push({
        path: '/access-control/device/center'
      })
    }
  },
  watch: {
    deviceType (v) {
      if (this.deviceType === '3' || this.deviceType === '4') {
        this.hasResponsiblePerson = false
        this.scenceList = [
          {code: '1', name: '公共场景'},
          {code: '2', name: '住户场景'},
          {code: '3', name: '其他场景'}
        ]
      } else {
        this.hasResponsiblePerson = true
        this.scenceList = [
          {code: '1', name: '公共场景'},
          {code: '2', name: '住户场景'},
          {code: '4', name: '预约场景'},
          {code: '3', name: '其他场景'}
        ]
      }
      this.getAllDeviceManufacture()
    },
    deviceName (v) {
      let ptn = pattern.basicAndCN.test(v)
      if (!ptn) {
        this.deviceNameVer = '<span style="color: red;">只允许输入中文，字母，数字，下划线</span>'
        this.deviceNameHttp = false
      } else {
        this.deviceNameVer = '<span>不超过32个字</span>'
        this.deviceNameHttp = true
      }
    },
    deviceCode (v) {
      let ptn = pattern.abd123.test(v)
      if (!ptn) {
        this.deviceCodeVer = '<span style="color: red;">只允许输入字母，数字</span>'
        this.deviceCodeHttp = false
      } else {
        this.deviceCodeVer = '<span>填写门禁设备序列号，与设备保持一致且唯一</span>'
        this.deviceCodeHttp = true
      }
    },
    scence (v) {
      if (v === '2') {

        // this.getEnterpriseInfoList()
        // this.getEnterpriseByCode()
      }
    },
    roomCode () {
      if (this.scence === '2') {
        this.getEnterpriseListByRoom()
        this.getEnterprisePerson()
      }
    },
    enterpriseCode () {
      this.getEnterprisePerson()
    },
    deviceManufacturer (v) {
      if (v === '100080') {
        this.hasParent = true
      }
      this.getAllDeviceType()
    },
    parentCode () {
      this.parentList.map(v => {
        if (v.deviceCode === this.parentCode) {
          this.parentName = v.deviceName
        }
      })
    },

  }
}
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .form-line>span {
    font-size: 12px;
    color: #97a8be;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 120px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/view/AccessCtrl/device-management/add-device.vue